<template>
  <div
    class="relative cursor-pointer focus:outline-none"
    :class="showDropdown && 'bg-gray-10 shadow'"
    tabindex="0"
    @focus="onFocus"
    @click="onClick"
    @blur="onBlur"
    v-click-outside="onBlur"
  >
    <AppTextField
      readonly
      padding-inset
      v-bind="$attrs"
      @enter="onFocus"
      :value="getSelectedDisplay(this.value)"
    >
      <template v-slot:right>
        <i class="material-icons type-scale-2 select-none">
          {{ showDropdown ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </i>
      </template>
    </AppTextField>
    <AppTransition>
      <ul
        class="absolute left-0 bg-gray-10 shadow min-w-full overflow-y-auto"
        v-if="showDropdown"
        style="top: calc(100% + 1px); max-height: 300px"
      >
        <li
          v-for="(option, $i) in options"
          :key="$i"
          @click.stop="onSelect(option)"
        >
          <slot
            :option="option"
            :selected="getSelectedDisplay(value) === option[displayKey]"
          />
        </li>
      </ul>
    </AppTransition>
  </div>
</template>

<script>
export default {
  name: 'AppSelectField',

  inheritAttrs: false,

  props: {
    value: null,
    displayKey: String,
    options: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showDropdown: false,
      selectedOption: null
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    getSelectedDisplay(value) {
      return value && this.displayKey ? value[this.displayKey] : value
    },

    onFocus() {
      this.showDropdown = true
    },

    onClick() {
      this.showDropdown = true
    },

    onBlur() {
      this.showDropdown = false
    },

    onSelect(option) {
      this.selectedValue = option
      this.showDropdown = false
    }
  }
}
</script>
